import http from './http.service';

class PersonService {
    constructor() {
        this.$http = http;
        this.baseUrl = "/api/person";
    }

    getById(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/GetById/${id}`);
    };

    getByIds(ids) {
        if (!ids) {
            throw new Error('Ids is required');
        }

        return this.$http.get(`${this.baseUrl}/GetByIds`, {
            params: { ids: ids.join() }
        });
    };

    getByUserId(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/GetByUserId/${id}`);
    };

    getChilderByUserId(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.get(`${this.baseUrl}/getChilderByUserId/${id}`);
    };

    update(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.put(`${this.baseUrl}`, model);
    };

    create(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/create`, model);
    };

    delete(id) {
        if (!id) {
            throw new Error('Id is required');
        }

        return this.$http.delete(`${this.baseUrl}`, { params: { id: id } });
    };

    addOrUpdateBankAccount(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/addOrUpdateBankAccount`, model)
    }

    getBankAccountById(personId) {
        if (!personId) {
            throw new Error('PersonId is required');
        }

        return this.$http.get(`${this.baseUrl}/GetBankAccountById/${personId}`);
    };

    getPersonFilesById(personId) {
        if (!personId) {
            throw new Error('PersonId is required');
        }

        return this.$http.get(`${this.baseUrl}/GetPersonFilesById/${personId}`);
    };

    deleteFiles(deletedIds, personId) {
        return this.$http.post(`${this.baseUrl}/DeleteFiles/${personId}`, deletedIds);
    };

    checkUserToPersonEmailMatch(model) {
        if (!model) {
            throw new Error('Model is required');
        }

        return this.$http.post(`${this.baseUrl}/checkUserToPersonEmailMatch`, model);
    };

    merge(persons) {
        if (!persons) {
            throw new Error('Persons is required');
        }

        return this.$http.post(`${this.baseUrl}/merge`, persons);
    };

    unmerge(personId) {
        if (!personId) {
            throw new Error('PersonId is required');
        }

        return this.$http.delete(`${this.baseUrl}/unmerge`, { params: { personId: personId } });
    };
}

export default new PersonService();
